import React from 'react';
import { Button, Col, Row } from 'antd';
import {
  BupSpinner,
  ErrorMessage,
  PageLayout,
  TitleSociogram,
} from '@BUP/components';
import { useHistory } from 'react-router';
import './styles.css';
import { useAuth, useGetSurveysSociogram } from '@BUP/hooks';
import { useTranslation } from 'react-i18next';

const SociogramPage = () => {
  const history = useHistory();
  const [t] = useTranslation();
  const { user } = useAuth();
  const {
    isLoadingSurveySociogram,
    surveySociogram,
    errorSurveySociogram,
  } = useGetSurveysSociogram(user);

  return (
    <PageLayout>
      {isLoadingSurveySociogram ? (
        <BupSpinner size="large" />
      ) : errorSurveySociogram ? (
        <>
          <h2>{errorSurveySociogram?.message || null}</h2>
          <ErrorMessage />
        </>
      ) : surveySociogram ? (
        <>
          <TitleSociogram title={t('pages.data.answerSociogram.title')} />
          <Row>
            <Col>
              <p>{t('pages.data.answerSociogram.sociogramDescription1')}</p>
              <p>{t('pages.data.answerSociogram.sociogramDescription2')}</p>
              <p>{t('pages.data.answerSociogram.sociogramDescription3')}</p>
            </Col>
            <Col span={24} align="end">
              <Button
                className="sociogramPage_start-button"
                type="primary"
                onClick={() => history.push('/data/sociogram/1')}
              >
                {t('pages.data.answerSociogram.buttonText')}
              </Button>
            </Col>
          </Row>
        </>
      ) : (
        <Row align="center">
          <Col className="sociogramPage__text_wrapper">
            <h2 className="text_no-sociogram">
              {t('pages.data.answerSociogram.noSociogramText')}
            </h2>
          </Col>
        </Row>
      )}
    </PageLayout>
  );
};

export default SociogramPage;
